import axios from 'axios'

function getInitializedApi (baseURL, headers = {}) {
  let axiosConfig = {
    baseURL: baseURL,
    headers: headers,
    responseType: 'json'
  }

  let api = axios.create(axiosConfig)

  return api
}

export default getInitializedApi



// WEBPACK FOOTER //
// ./src/api/index.js